module.exports = __webpack_public_path__ + "static/media/empty_project.c4680e43.svg";